import { z } from "zod";

const formSubmissionErrorSchema = z.object({
  title: z.string().optional().nullable(),
  message: z.string(),
  detail: z.string().optional().nullable(),
  violations: z
    .array(z.object({ field: z.string(), message: z.string() }))
    .optional()
});

export const isFormSubmissionError = formSubmissionErrorSchema.safeParse;
export type FormSubmissionError = z.infer<typeof formSubmissionErrorSchema>;
